export function formatToHumanDateTime(dateStr) {
  if (!dateStr) {
    return
  }
  let date;

  // Handle "YYYY-MM-DD" or "YYYY-MM-DD HH:mm"
  if (dateStr.includes('-')) {
    date = new Date(dateStr.replace(' ', 'T'));
  } else {
    return 'Invalid date';
  }

  if (isNaN(date)) return 'Invalid date';

  const day = date.getDate();
  const month = date.toLocaleString('default', { month: 'long' });
  const year = date.getFullYear();
  const suffix = getDaySuffix(day);

  let formatted = `${day}${suffix} ${month} ${year}`;

  // Only include time if it's provided
  if (dateStr.includes(':')) {
    const time = date.toLocaleTimeString([], {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
    });
    formatted += `, ${time}`;
  }

  return formatted;
}

function getDaySuffix(day) {
  if (day >= 11 && day <= 13) return 'th';
  switch (day % 10) {
    case 1: return 'st';
    case 2: return 'nd';
    case 3: return 'rd';
    default: return 'th';
  }
}
